import { queryOptions, useQuery } from '@tanstack/react-query';
import { fetchSlcpAnalytics } from '@/api/(admin)/slcp-analytics';
import type { SlcpDateRange } from '../-types';
import { toQueryString } from '../-utils/dateRange';

/**
 * Shared by the route loader and the page hook.
 *
 * Keyed on the built querystring rather than on the range object, so an absent
 * bound and an empty-string bound land on one cache entry instead of two that
 * fetch the same thing.
 */
export function slcpAnalyticsQueryOptions(range: SlcpDateRange) {
  const qs = toQueryString(range);
  return queryOptions({
    queryKey: ['admin', 'slcp-analytics', qs] as const,
    queryFn: () => fetchSlcpAnalytics(qs),
    staleTime: 60_000,
  });
}

export function useSlcpAnalytics(range: SlcpDateRange) {
  return useQuery(slcpAnalyticsQueryOptions(range));
}
